module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section",
    attrs: {
      "id": "sect4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/toc#sect4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southern Johnny Cakes")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    staticStyle: {
      "height": "70vh"
    },
    attrs: {
      "alt": "",
      "src": "OEBPS/images/10-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "RecipebYieldb"
  }, [_vm._v("Yield: Serves 4–6 | Prep Time: 5 minutes | Cook Time: 10–12 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extract_r"
  }, [_vm._v("Johnny cakes are an American classic both in the Northeast and in the South. The addition of whole wheat flour helps add fiber, so if you want to indulge in a bit of maple syrup to top them off, go ahead!")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ cup whole wheat flour")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 cup self-rising cornmeal")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 teaspoon baking powder")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 tablespoon sugar")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ teaspoon kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2 large eggs, lightly beaten")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 cup buttermilk")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 tablespoon unsalted butter, melted")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2 teaspoons vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("Greek yogurt and fresh berries for topping")]), _vm._v(" "), _c('p', {
    staticClass: "directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("1. In a large bowl, combine the flour, cornmeal, baking powder, sugar, and salt.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("2. Whisk in the eggs, buttermilk, butter, and vanilla.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("3. Coat a griddle or skillet with cooking spray and heat over medium-high heat.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("4. Drop about ¼ cup of the batter per cake onto the griddle and cook for 2 to 3 minutes per side until golden brown.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("5. Serve with Greek yogurt and fresh berries.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-093019ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/sect4.vue
// module id = 96
// module chunks = 0